import { screens } from "../../../constants/constants";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const IocoText = ({
  onCurtainStart,
  gridArea,
}: {
  onCurtainStart: ({
    curtainTo,
    horizontal,
  }: {
    curtainTo: string;
    horizontal?: boolean;
  }) => void;
  gridArea: string;
}) => {
  const { h } = useWindowSize();

  return (
    <div
      style={{
        gridArea,
        fontWeight: 500,
        cursor: "pointer",
        fontSize: h(3),
        lineHeight: h(3),
        zIndex: 99,
      }}
      onClick={() => {
        onCurtainStart({ curtainTo: screens.landing });
      }}
    >
      IOCO
    </div>
  );
};
